<template>
    <div class="mb-5 font-light">
        <h3 class="mb-1 text-sm font-normal text-openhours-title-c">{{ $t('open-hours-title') }}</h3>
        <DayOpenHour class="py-1" v-for="d in sortedOpenHours" :key="d.id" :dayName="mapDayTypeToDayNameI18N(d.dayType)" :morningTime="d.start" :afternoonTime="d.finish" />
    </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { CustomWeekDaysEnum } from '@/enums/CustomWeekDaysEnum';
import { APISharedDTOOnlineBookingWorkingHourItemDto } from '../../../generated';
import DayOpenHour from './DayOpenHour.vue';

const props = defineProps({
    dateList: {
        type: Array as PropType<APISharedDTOOnlineBookingWorkingHourItemDto[]>,
        required: true,
    },
});

const { t } = useI18n();

const sortedOpenHours = computed(() => {
    if (!props.dateList) {
        return;
    }

    // Custom order of days
    const customDayOrder = Object.values(CustomWeekDaysEnum);

    return props.dateList
        .slice()
        .sort((a, b) => {
            if (!a.dayType || !b.dayType) return 0;
            const dayA = customDayOrder.indexOf(a.dayType as CustomWeekDaysEnum);
            const dayB = customDayOrder.indexOf(b.dayType as CustomWeekDaysEnum);

            return dayA - dayB;
        })
        .filter((d) => d.opened === true);
});

const mapDayTypeToDayNameI18N = (dayType: string) => {
    switch (dayType) {
        case CustomWeekDaysEnum.MON:
            return t('primeVue.dayNames.1');
        case CustomWeekDaysEnum.TUE:
            return t('primeVue.dayNames.2');
        case CustomWeekDaysEnum.WED:
            return t('primeVue.dayNames.3');
        case CustomWeekDaysEnum.THU:
            return t('primeVue.dayNames.4');
        case CustomWeekDaysEnum.FRI:
            return t('primeVue.dayNames.5');
        case CustomWeekDaysEnum.SAT:
            return t('primeVue.dayNames.6');
        case CustomWeekDaysEnum.SUN:
            return t('primeVue.dayNames.0');
        default:
            return '';
    }
};
</script>
